export default __webpack_public_path__ + "static/media/redo-arrow.c46c2f09.webp";